module.exports = __webpack_public_path__ + "static/media/robot.acda02e0.svg";